import { useDiningBookingMatches } from "./diningBookingLinks";

const statusLabel = status => ({ pending: "Pending", confirmed: "Confirmed", sent_to_kitchen: "Sent to kitchen" }[status] || status || "Status not set");
export default function DiningBookingPanel({ event, user, onOpen }) {
  const { records = [], loading, error, allowed, retry } = useDiningBookingMatches(event, user);
  if (!allowed) return null;
  return <section aria-label="Dining booking" className="cc-card cc-dining-summary">
    <h3>Dining booking</h3>
    {loading ? <p role="status">Checking dining bookings…</p> : error ? <p role="alert">{error} <button type="button" onClick={retry}>Retry dining lookup</button></p> : <>
      {records.length === 0 && <p>No active catering booking for this lodge on this date.</p>}
      {records.length === 1 && <p className="cc-muted">Matched by lodge number and date.</p>}
      {records.length > 1 && <p className="cc-warning">Multiple catering bookings match this lodge and date. Choose the booking you want to view.</p>}
      {records.map(booking => <div key={booking.id} className="cc-dining-booking">
        <p><strong>{booking.time || "Time not set"}</strong> · {statusLabel(booking.status)}</p>
        <p>{booking.courseCount === "buffet" ? "Buffet" : [1, 2, 3].includes(Number(booking.courseCount)) ? `${booking.courseCount} course${Number(booking.courseCount) === 1 ? "" : "s"}` : "Courses not set"} · {booking.diners ?? "Not set"} diners</p>
        {onOpen && <button type="button" onClick={() => onOpen({ id: booking.id, lodgeNumber: booking.lodgeNumber, date: booking.date })}>Open dining booking{records.length > 1 ? ` — ${booking.time || booking.id}` : ""}</button>}
      </div>)}
    </>}
    <p className="cc-muted">Calendar changes do not amend the catering booking.</p>
  </section>;
}
